import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Container,
  Row
} from 'reactstrap';

import Sneaker from '../../components/Sneakers/Sneaker';
import CardLoading from '../../components/Loading/CardLoading';
import { CardNotFound } from 'components/PageSearchDetails';

class Content extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  renderProducts() {
    const isUnreleased = this.props.statusPage === 'unreleased' ? false : true;
    const { searchResult, stillPending } = this.props.dataProduct;
    if (stillPending && (searchResult && searchResult.length === 0)) {
      return <CardLoading />
    } else if (searchResult && searchResult.length === 0 || !searchResult) {
      return (
        <CardNotFound title='This collection is still empty.' text='Stay tuned for more exciting selections in this section, do not miss out!' />
      )
    } else {
      return searchResult.map((item, index) => {
        return (
          <Sneaker hotProducts={item.editors_choice} {...item} category={item?.product?.category?.name || 'all_category'} key={index} outOfStock={isUnreleased} statusPage={this.props.statusPage} />
        )
      })
    }
  }

  render() {
    return (
      <Container fluid>
        <div className="product-list">
          <div id="product">
            <Row style={{ minHeight: 500, display: 'flex', alignItems: 'flex-start', flexDirection: 'row' }}>
              {this.renderProducts()}
            </Row>
          </div>
        </div>
      </Container>
    )
  }
}

const mapStateProps = state => ({
  dataProduct: state.dataProduct,
  dataCategory: state.dataCategory.selected
})

export default connect(mapStateProps, null)(Content);
